import {
  ShineStartDocumentStatus,
  ShineStartDocumentType,
} from '__generated__/GQL';
import assertEventType from 'common/bento/lib/assertEventType';
import { MachineGuards } from 'common/bento/types/MachineConfig';

import getSelectedDocument from '../libs/getSelectedDocument';
import { Model } from './model';

export enum Guard {
  IsSelectedDocumentRefused = 'isSelectedDocumentRefused',
  IsSelectedDocumentHandWrittenProofOfIdentity = 'isSelectedDocumentHandWrittenProofOfIdentity',
  ShouldSkipIntro = 'shouldSkipIntro',
}

const guards: MachineGuards<Model, Guard> = {
  isSelectedDocumentHandWrittenProofOfIdentity: ({ getModuleData }, event) => {
    assertEventType(event, 'SELECT_DOCUMENT');

    const selectedDocument = getSelectedDocument({
      moduleData: getModuleData(),
      selectedDocumentId: event.documentId,
    });

    return (
      selectedDocument?.type ===
      ShineStartDocumentType.ProofOfIdentityHandWritten
    );
  },
  isSelectedDocumentRefused: ({ getModuleData, selectedDocumentId }) => {
    const selectedDocument = getSelectedDocument({
      moduleData: getModuleData(),
      selectedDocumentId,
    });

    return selectedDocument?.status === ShineStartDocumentStatus.Refused;
  },
  shouldSkipIntro: ({ getModuleData }) =>
    getModuleData().data.viewer.company.shineStart.stepStatus === 'error',
};

export default guards;
